export class FakeImmutableMap<K, V> implements ReadonlyMap<K, V> {
  readonly #map: Map<K, V>

  constructor(map = new Map<K, V>()) {
    this.#map = map
  }

  get size() {
    return this.#map.size
  }

  [Symbol.iterator](): MapIterator<[K, V]> {
    return this.#map[Symbol.iterator]()
  }

  forEach(callbackfn: (value: V, key: K, map: ReadonlyMap<K, V>) => void, thisArg?: any): void {
    this.#map.forEach((value, key) => callbackfn.call(thisArg ?? this, value, key, this))
  }

  entries() {
    return this.#map.entries()
  }

  keys() {
    return this.#map.keys()
  }

  values() {
    return this.#map.values()
  }

  has(key: K): boolean {
    return this.#map.has(key)
  }

  get(key: K) {
    return this.#map.get(key)
  }

  set(key: K, value: V) {
    this.#map.set(key, value)
    return new FakeImmutableMap(this.#map)
  }

  delete(key: K) {
    return this.#map.delete(key) ? new FakeImmutableMap(this.#map) : this
  }

  updateValues(update: (value: V, key: K) => V) {
    for (const [key, value] of this.entries()) {
      this.#map.set(key, update(value, key))
    }
    return new FakeImmutableMap(this.#map)
  }
}
